(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-1-hero-with-image"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(scroller) {
      var track = scroller.querySelector('.ps-row');
      var prev = scroller.querySelector('.ps-arrow--prev');
      var next = scroller.querySelector('.ps-arrow--next');
      if (!track || !prev || !next) return;
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.82, behavior: 'smooth' }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
    }
    document.querySelectorAll('.ps-scroller--on').forEach(wire);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-2-key-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(scroller) {
      var track = scroller.querySelector('.ps-row');
      var prev = scroller.querySelector('.ps-arrow--prev');
      var next = scroller.querySelector('.ps-arrow--next');
      if (!track || !prev || !next) return;
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.82, behavior: 'smooth' }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
    }
    document.querySelectorAll('.ps-scroller--on').forEach(wire);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-3-auraflow-vs-the-rest"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(scroller) {
      var track = scroller.querySelector('.ps-row');
      var prev = scroller.querySelector('.ps-arrow--prev');
      var next = scroller.querySelector('.ps-arrow--next');
      if (!track || !prev || !next) return;
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.82, behavior: 'smooth' }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
    }
    document.querySelectorAll('.ps-scroller--on').forEach(wire);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-4-auraflow-earbuds-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(scroller) {
      var track = scroller.querySelector('.ps-row');
      var prev = scroller.querySelector('.ps-arrow--prev');
      var next = scroller.querySelector('.ps-arrow--next');
      if (!track || !prev || !next) return;
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.82, behavior: 'smooth' }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
    }
    document.querySelectorAll('.ps-scroller--on').forEach(wire);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-5-pre-order-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(scroller) {
      var track = scroller.querySelector('.ps-row');
      var prev = scroller.querySelector('.ps-arrow--prev');
      var next = scroller.querySelector('.ps-arrow--next');
      if (!track || !prev || !next) return;
      function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.82, behavior: 'smooth' }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
    }
    document.querySelectorAll('.ps-scroller--on').forEach(wire);
  })();

  } catch(e) { console.error(e); }
})();
})();
